
<!------------------------- header start ------------------------------>
<header>
  <!-- navbar start -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand ms-5" routerLink="/home"><img src="/assets/expert-ask/image/logo.svg" alt="Logo" /></a>
      <button class="navbar-toggler navbar-light" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  routerLink="/about">About </a>
          </li>


        </ul>
      </div>

      <ul class="navbar-nav last-navbar ms-lg-auto ms-0 mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link btn-orange" href="#">Get a quota</a>
        </li>
        <li class="nav-item user">
          <a class="nav-link" href="#"> <i class="far fa-user"></i> </a>
        </li>
      </ul>
    </div>
  </nav>

  <!-- navbar end -->


  <!-- hero area start -->
  <section class="hero-area">
    <div class="hero-body">
      <p class="hero-paragraph">Ask The Expert</p>
      <h2 class="h1 hero-header px-lg-5">Answers to All of Your Real Estate Insurance Questions</h2>

      <div class="hero-owner">
        <img src="/assets/expert-ask/image/Ellipse2.png" class="my-3" alt="Photo" />
        <p><b>Manny Rios</b></p>
        <p>Chief Underwiriting Officer</p>
      </div>
    </div>
  </section>
  <!-- hero area end -->
</header>
<!------------------------- header end ------------------------------>

<!----------------------- quetions start ----------------------->

<section class="questions">
  <div class="container">
    <nav class="qu-nav">
      <a href="#" class="qu-link active">Populer</a>
      <a href="#" class="qu-link">COVID-19</a>
      <a href="#" class="qu-link">HOA</a>
      <a href="#" class="qu-link">Category 3</a>
      <a href="#" class="qu-link">Category 4</a>

      <form class="position-relative search-form">
        <div class="search-box">
          <input type="text" name="search" id="search-txt" placeholder="Search" />
          <span class="search-btn">
                                <i class="fas fa-search"></i>
                            </span>
        </div>
      </form>
    </nav>

    <hr class="d-md-block d-none" />

    <div class="row question-row">
      <div class="col-md-6 my-4">
        <h3>When Should Condo or Homeowner Association Boards Typically Start Thinking About Renewing Insurance?</h3>
        <a href="#" class="btn-white">HQA</a>
      </div>
      <div class="col-md-6 my-4">
        <h3>What Are The Projected Rates of Insurance for 2021?</h3>
        <a href="#" class="btn-white">HQA</a>
      </div>
      <div class="col-md-6 my-4">
        <h3>What is D&O Liability?</h3>
        <a href="#" class="btn-white">COVID-19</a>
      </div>
      <div class="col-md-6 my-4">
        <h3>How Do I know if I have the right coverage for my Property?</h3>
        <a href="#" class="btn-white">Property Managers</a>
      </div>
    </div>
  </div>
</section>

<!----------------------- quetions end ----------------------->


<!-----------------------  coverage start ----------------------->
<section class="coverage">
  <div class="container">
    <div class="coverage-body">
      <div class="row">
        <div class="col-md-6">
          <h3>Better coverage is closer than you think</h3>
        </div>
        <div class="col-md-6 px-5 pt-4">
          <p class="coverage-text coverage-text1">Tell us about your property</p>
          <p class="coverage-text coverage-text2">Get an instant, personalized quote</p>
          <p class="coverage-text coverage-text3">Enjoy up to 50% savings</p>
        </div>
        <div class="col-md-6">
          <p class="text-center mt-md-0 mt-5"><a href="#" class="btn-orange d-block w-50 mx-auto">Get Start</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-----------------------  social start ----------------------->
<div class="social py-5">
  <div class="container-fluid">
    <a routerLink="/home">
      <img src="/assets/image/Vector.svg" class="d-lg-block d-none mx-auto" alt="Logo" />
    </a>
    <a routerLink="/home">
      <img src="/assets/Coverage/image/logo.svg" class="d-lg-none d-block mx-auto" alt="Logo">
    </a>
  </div>
  <p class="social-links text-center d-lg-none d-block mt-4">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
  <nav>
    <div class="container-fluid my-5">
      <p class="text-center">
        <a routerLink="/coverage">Coverage</a>
        <a routerLink="/learningCenter">Learning Center</a>
        <a routerLink="expertAsk">Ask The Expert</a>
        <a routerLink="/about">About</a>
      </p>
    </div>
  </nav>

  <p class="social-links text-center d-lg-block d-none">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
</div>
<!-----------------------  social end ----------------------->
<!------------------------- footer start ------------------------------>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p class="text-lg-left d-lg-block d-none text-center"> &#169; 2020 Honeycomb Insurance. All rights reserved.</p>
        <p class="text-lg-left d-lg-none d-block text-center"> &#169; © 2020 Acme. All right reserved.</p>
      </div>
      <div class="col-lg-6">
        <p class="text-lg-right text-center">
          <a href="#" class="d-lg-inline d-block">Privacy Policy</a>
          <a href="#" class="d-lg-inline d-block my-4">Terms of Service</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!------------------------- footer end ------------------------------>
